var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.27 2.83292L9.575 1.92292C9.44 1.73875 9.235 1.625 9 1.625H3C2.765 1.625 2.56 1.73875 2.42 1.92292L1.73 2.83292C1.585 3.01708 1.5 3.26083 1.5 3.52083V10.2917C1.5 10.8875 1.95 11.375 2.5 11.375H9.5C10.05 11.375 10.5 10.8875 10.5 10.2917V3.52083C10.5 3.26083 10.415 3.01708 10.27 2.83292ZM3.12 2.70833H8.88L9.285 3.23375H2.72L3.12 2.70833ZM2.5 10.2917V4.33333H9.5V10.2917H2.5ZM6.725 5.41667H5.275V7.04167H4L6 9.20833L8 7.04167H6.725V5.41667Z",
    fill: "#F5B309"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.8d61f73bd371c06415b3c69d23fb4896.svg";
export { ForwardRef as ReactComponent };